module.exports = __webpack_public_path__ + "static/media/data-analysislo.babba8bc.jpg";